<input
  [value]="
    escapeHtml
      ? (((selectedOption?.element?.nativeElement?.innerHTML || value) ?? null) | deserializeHtmlCharacterEntities)
      : value ?? null
  "
  (click)="selectText($event.target)"
  [readOnly]="readonly"
  (input)="updateOn === 'input' && setValue(inputElement.value)"
  (blur)="updateOn === 'blur' && setValue(inputElement.value); onTouch()"
  placeholder="{{
    placeholder || '#UI_CORE.COMPONENTS.COMBO_BOX.PLACEHOLDER' | translate
  }}"
  #inputElement
  />

@if (isOpen) {
  <div
    class="combo-box-panel soft-scroll vertical"
    (softClickOutside)="onOutsideClick()"
    [delayClickOutsideInit]="true"
    >
    @for (option of options; track option) {
      <div
        class="combo-box-select-option pointer"
        [class.selected]="option.value === value"
        [softScrollIntoView]="value === option.value"
        (click)="onSelect(option.value)"
        >
        @if ((option.element.nativeElement.innerHTML || option.value)) {
          <span
            [innerHTML]="(option.element.nativeElement.innerHTML || option.value) | secureHtml">
          </span>
        }
      </div>
    }
  </div>
}
<ng-content select=":not(soft-combo-box-option)"></ng-content>
@if (!readonly && isOpen) {
  <i
    (click)="isOpen = false"
    class="fa-regular fa-chevron-up expand-icon pointer ml-4"
  ></i>
}
@if (!readonly && !isOpen) {
  <i
    (click)="isOpen = true"
    class="fa-regular fa-chevron-down expand-icon pointer ml-4"
  ></i>
}

@if (isOpen) {
  <span
    class="soft-backdrop mobile-only z-300"
    (click)="onOutsideClick()"
  ></span>
}
